import { UseTotpModalReturn } from "@synota-io/synota-shared-ui";
import { AxiosInstance } from "axios";
import { createContext } from "react";

export interface IHttpContext {
  client: AxiosInstance;
  totp: UseTotpModalReturn;
}

export const HttpContext = createContext<IHttpContext | null>(null);
